@@ -0,0 +1,78 @@
<template>
  <material-card
    :title="$t('components.benefits.benefits_index')"
    icon="mdi-tag-heart-outline"
    v-if="options"
  >
    <template v-slot:actions>
      <div style="margin-right:20px;margin-top: 10px;">
        <v-btn @click="dialogs.importBenefits = true" color="primary">
          {{ $t("components.guides.import_benefits_dialog.import_benefits") }}
        </v-btn>
      </div>
    </template>
    <pbas-data-table
    :exporters="$exporters"
      ref="table"
      :dataProvider="provider"
      @error="error = $event"
      :rowActions="rowActions"
      :floatActions="floatActions"
      :selectActions="selectActions"
      fileNamePrefix="benefits_index"
      identifier="benefits_index"
    ></pbas-data-table>
    <import-benefits-dialog
      @close="
        dialogs.importBenefits = false;
        item = null;
      "
      @success="
        dialogs.importBenefits = false;
        message = $event;
        snackbar = true;
        $refs.table.getDataAsync();
      "
      :model="dialogs.importBenefits"
    />
    <benefit-form-dialog
      @close="
        dialogs.edit = false;
        item = null;
      "
      @success="
        dialogs.edit = false;
        message = $event;
        snackbar = true;
        $refs.table.getDataAsync();
        item = null;
      "
      :model="dialogs.edit"
      :item="item"
    />
    <v-dialog scrollable v-model="dialogs.delete" persistent max-width="400">
      <material-card
        :title="deleteTitle"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.delete = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="tryDelete">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import getBenefitHeaders from "@/headers/BenefitsIndex";
import ErrorHandler from "@/components/ErrorHandler";
import ImportBenefitsDialog from "@/components/Benefits/ImportBenefitsDialog";
import BenefitFormDialog from "@/components/Benefits/BenefitFormDialog";
import { translate2 } from "../../trans2";
export default {
  components: {
    ErrorHandler,
    ImportBenefitsDialog,
    BenefitFormDialog,
  },
  data() {
    return {
      error: null,
      provider: undefined,
      dialogs: {
        importBenefits: false,
        edit: false,
        delete: false,
      },
      item: null,
      selected: [],
      deleteTitle:"",
      selectActions: [
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (items) => {
            this.selected = items;
            this.deleteTitle = this.$t(
              "components.benefits.benefits_table.delete_selected_benefits",
            );
            this.dialogs.delete = true;
          },
        },
      ],
      floatActions: [
        {
          name: "addItem",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => {
            this.item = {};
            this.dialogs.edit = true;
          },
        },
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.item = JSON.parse(JSON.stringify(item));
            this.dialogs.edit = true;
          },
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.selected = [item];
            this.deleteTitle = this.$t(
              "components.benefits.benefits_table.delete_benefit_{0}",
              [translate2(item, "Name")]
            );
            this.dialogs.delete = true;
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters("common", {
      settings: "settings",
    }),
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    options: {
      handler(v) {
        if (v) {
          this.loadData();
        }
      },
    },
  },
  mounted() {
    if (this.options) {
      this.loadData();
    }
  },
  methods: {
    ...mapActions("claims", ["deleteBenefits"]),
    loadData() {
      this.provider = new ODataProvider(
        this.$axiosHttp,
        this.settings.APIURL + "benefits",
        getBenefitHeaders(this.options.Enums.Coverage)
      );
    },
    async tryDelete() {
      try {
        this.saving = true;
        await this.deleteBenefits({
          payload: {
            Ids: this.selected.map(o=>o.Id),
          },
        });
        this.dialogs.delete = false;
        this.message = this.$t("globals.success");
        this.snackbar = true;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
